import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {CommonUtils} from '../../utils/common';
import {CsvReportField} from '../../models/csv-report-field.interface';
import CSVFields from '../../../assets/csv-report-fields.json';
import AirDatepicker from "air-datepicker";
import pl from "air-datepicker/locale/pl";

@Component({
  selector: 'app-vet-clinic-report-modal',
  templateUrl: './vet-clinic-report-modal.component.html',
  styleUrls: ['./vet-clinic-report-modal.component.scss'],
})
export class VetClinicReportModalComponent implements OnInit {


  @Input() title;
  @Input() date;
  @ViewChild('dateInput') datepickerRef: ElementRef;
  dateFrom: string;
  dateFromMaxDate: string;
  dateToMinDate: string;
  dateTo: string;
  minDate: string;
  maxDate: string;
  byPaymentConfirmationDate: boolean = false;
  isCustomReport: boolean;
  skipRefunds: boolean = false;
  currentDate: Date;
  vetReservationSelectHeader: any = {
    header: 'Wybierz pola z rezerwacji'
  };
  orderSelectHeader: any = {
    header: 'Wybierz pola z zamówienia'
  };
  vetReservationSelectOptions: CsvReportField[] = [];
  orderSelectOptions: CsvReportField[] = [];
  allSelectOptions: CsvReportField[] = [];
  pickedOrderSelectOptions: CsvReportField[];
  pickedVetReservationSelectOptions: CsvReportField[];

  private dateFromInDate: Date;
  private dateToInDate: Date;


  constructor(private modalController: ModalController,
              private commonUtils: CommonUtils, private renderer: Renderer2) { }

  ngOnInit() {

    this.allSelectOptions = CSVFields;
    this.vetReservationSelectOptions = this.allSelectOptions.filter(reportField => reportField.objectType === 'VetReservation');
    this.orderSelectOptions = this.allSelectOptions.filter(reportField => reportField.objectType === 'Order');

    console.log(this.orderSelectOptions);
    console.log(this.vetReservationSelectOptions);
    this.isCustomReport = false;
    this.currentDate = new Date();
    const tempDateString = new Date(this.date).toString();
    if (tempDateString !== 'Invalid Date') {
      this.minDate = this.commonUtils.dateToYearMonthDayString(new Date(this.date));
    } else {
      this.minDate = this.commonUtils.dateToYearMonthDayString(new Date(2022, 0, 1));
    }
    this.maxDate = this.commonUtils.dateToYearMonthDayString(this.currentDate);
    this.dateFromMaxDate = this.commonUtils.dateToYearMonthDayString(new Date(new Date(this.maxDate).getTime() - 86400000));
    this.dateFrom = this.commonUtils.dateToYearMonthDayString(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1));
    this.dateFromInDate = new Date(this.dateFrom);
    this.dateToMinDate = this.commonUtils.dateToYearMonthDayString( new Date(new Date(this.dateFrom).getTime() + 86400000));
    this.dateTo = this.maxDate;
    this.dateToInDate = new Date(this.dateTo);

    setTimeout(() => {
      const datepicker = this.datepickerRef.nativeElement as HTMLDivElement;
      new AirDatepicker(datepicker, {
        range: true,
        locale: pl,
        maxDate: this.maxDate,
        selectedDates: [this.dateFrom, this.maxDate],
        onSelect: ({date, formattedDate, datepicker}) => {
          if (Array.isArray(date) && date.length === 2) {
            console.log(formattedDate);
            this.dateFrom = formattedDate[0];
            this.dateFromInDate = new Date(this.dateFrom);
            this.dateTo = formattedDate[1];
            this.dateToInDate = new Date(this.dateTo);
          }
        }
      });

      const childrenIterator = datepicker.children[Symbol.iterator]();

      let child = childrenIterator.next().value;

      while (child) {
        this.renderer.setStyle(child, 'width', '100%');
        child = childrenIterator.next().value;
      }

    }, 0);


  }

  getDateToMinDate() {
    return this.dateToMinDate;
  }

  onClose() {
    this.modalController.dismiss(null);
  }
  onSubmit() {
    this.modalController.dismiss(this.getFinalReturnValues(), 'submit');
  }

  getFinalReturnValues() {

    const returnObj = {
      dateFrom: this.dateFrom.concat(' ', '00:00'),
      dateTo: this.dateTo.concat(' ', '23:59'),
      csvReportFields: [],
      byPaymentConfirmationDate: this.byPaymentConfirmationDate,
      skipRefunds: this.skipRefunds
    };
    if (this.isCustomReport) {
      if (this.pickedOrderSelectOptions !== undefined && this.pickedVetReservationSelectOptions !== undefined) {
        returnObj.csvReportFields = this.pickedVetReservationSelectOptions.concat(this.pickedOrderSelectOptions);
      } else if (this.pickedVetReservationSelectOptions === undefined && this.pickedOrderSelectOptions !== undefined) {
        returnObj.csvReportFields = this.pickedOrderSelectOptions;
      } else if (this.pickedOrderSelectOptions === undefined && this.pickedVetReservationSelectOptions !== undefined) {
        returnObj.csvReportFields = this.pickedVetReservationSelectOptions;
      } else {
        returnObj.csvReportFields = [];
      }
    }
    return returnObj;
  }

  onCalendarChanged(dateString: string, $event: any) {
    if($event.detail.value) {
      if (dateString === 'from') {
        this.dateFrom = $event.detail.value;
        this.dateFromInDate = new Date(this.dateFrom);
        this.dateToMinDate = this.commonUtils.dateToYearMonthDayString( new Date(new Date(this.dateFrom).getTime() + 86400000));
      } else {
        this.dateTo = $event.detail.value;
        this.dateToInDate = new Date(this.dateTo);
      }
    }

  }

  invalidDates() {
    return this.dateFromInDate >= this.dateToInDate;
  }

  toggleCustomReport($event) {
    this.isCustomReport = $event.detail.checked;
  }

  toggleSkipRefunds($event) {
    this.skipRefunds = $event.detail.checked;
  }

  vetReservationSelectChange($event: any) {
    this.pickedVetReservationSelectOptions = $event.detail.value;
  }

  orderSelectChange($event: any) {
    this.pickedOrderSelectOptions = $event.detail.value;
  }

  isSubmitDisabled() {
     return (this.invalidDates() ||
       (this.isCustomReport && (this.pickedOrderSelectOptions === undefined || this.pickedOrderSelectOptions?.length === 0)
         && (this.pickedVetReservationSelectOptions === undefined || this.pickedVetReservationSelectOptions?.length === 0)));
  }

  translateVetReservationField(field: any) {
    return this.commonUtils.translateReservation(field);
  }

  translateOrderField(field: any) {
    return this.commonUtils.translateOrder(field);
  }

  toggleByPaymentConfirmationDate($event) {
    this.byPaymentConfirmationDate = $event.detail.checked;

  }
}
